import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import axios from "axios";

const MobileNavbarStudent = (props) => {
    const { t } = useTranslation()
    const { user } = useAuth();
    const [logo, setLogo] = useState('');
    const getlogo = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
            await axios({
                method: 'get',
                url: "https://express.heryerdeingilizce.com/getlogo",
                headers: headerss
            }).then(res => {
                setLogo(res.data[0])
            }
            );
        }
        catch (err) {
        }
    }
    useEffect(() => {
        getlogo();
    }, [])
    return (
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
            <div class="container-fluid" style={{ backgroundColor: "white" }}>
                <a className="navbar-brand d-flex align-items-center" href="/">
                    {logo && logo['photo'] ? (
                        <img
                            src={logo['photo']}
                            alt="logo"
                            className="img-fluid"
                            style={{ maxHeight: "45px", objectFit: "contain" }}
                        />
                    ) : (
                        <span className="fw-bold text-primary">LMS Admin</span>
                    )}
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <a href='/user/course'  >
                            <b>  {t('course')}</b>
                        </a>
                        <hr />
                        <a href='/usergeneral'  >
                            <b> {t('generalreport')}</b>
                        </a>
                        <hr />
                        <a href='/userskill'  >
                            <b> {t('skills')}</b>
                        </a>
                    </ul>
                    <hr />
                    <form class="d-flex" style={{ padding: "3%" }}>
                        <a href="/profile">
                            <i
                                class="fa fa-user-circle"
                                style={{ fontSize: 30 }}
                                aria-hidden="true"
                            >
                            </i>
                            &nbsp;
                            <span>

                                <strong>{user.name}</strong>
                                <br />
                                {user.role}
                            </span>
                        </a>
                    </form>
                </div>
            </div>
        </nav >
    );
};

export default MobileNavbarStudent;